import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { RelationshipStatus, RelationshipV2 } from 'support/types';
import { TabsList } from 'components/Navigation/Tabs/TabsList';

import { ConnectionSetupStep } from '../../hooks/useSetupConnectionSteps/useSetupConnectionSteps';
import { ConnectionSetupTab } from './ConnectionSetupTab/ConnectionSetupTab';
import { TransactionsTab } from './TransactionsTab/TransactionsTab';

type RelationshipDetailsTabsProps = {
  relationship: RelationshipV2;
  steps: Array<ConnectionSetupStep>;
};

const TRANSACTIONS_TAB = 0;
const CONNECTION_SETUP_TAB = 1;

export const RelationshipDetailsTabs = ({ relationship, steps }: RelationshipDetailsTabsProps) => {
  const { t } = useTranslation();
  const [selectedTab, setSelectedTab] = useState(TRANSACTIONS_TAB);

  const isLiveOrActive = [RelationshipStatus.LIVE, RelationshipStatus.ACTIVE].includes(
    RelationshipStatus[relationship.status],
  );

  const tabs = useMemo(
    () => [
      { label: t('connections:relationshipDetails.tabs.transactions') },
      { label: t('connections:relationshipDetails.tabs.connectionSetup') },
    ],
    [t],
  );

  if (!isLiveOrActive) {
    return <ConnectionSetupTab relationship={relationship} steps={steps} />;
  }

  return (
    <div className="-mt-4 space-y-6">
      <TabsList tabs={tabs} onChange={setSelectedTab} selected={selectedTab} />
      {selectedTab === TRANSACTIONS_TAB && <TransactionsTab relationship={relationship} />}
      {selectedTab === CONNECTION_SETUP_TAB && <ConnectionSetupTab relationship={relationship} steps={steps} />}
    </div>
  );
};
